import { render, staticRenderFns } from "./SampleReceivingLabels.vue?vue&type=template&id=bed5bd66"
import script from "./SampleReceivingLabels.vue?vue&type=script&lang=js"
export * from "./SampleReceivingLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports